export { NgwWowModule } from './wow.module';
export { NgwWowConfig } from './models/index';
export { WindowService, NgwWowService } from './services/index';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-wow/index.js
// module id = ./node_modules/ngx-wow/index.js
// module chunks = vendor